import { Link, createFileRoute } from '@tanstack/react-router'
import { Tag } from 'lucide-react'
import { useLabelTaskCounts } from '../hooks/useLabelTaskCounts'
import { Badge } from '@/components/ui/badge'
import { useTaskPageSetup } from '@/hooks'
import { useAllLabels } from '@/lib/hooks/useLabels'
import { TaskEmptyState } from '@/routes/features/tasks/components/TaskEmptyState'
import useLoginStore from '@/store/LoginStore'
import { PhoneMenuButton } from '@/components/app/layout/PhoneMenuButton'

export const Route = createFileRoute(
  '/_AppWrapper/_AppLayout/$workspaceSlug/tags/',
)({
  component: TagListPage,
})

function TagListPage() {
  useTaskPageSetup()
  const workspaceId = useLoginStore((state) => state.workspaceId)
  const workspaceSlug = useLoginStore((state) => state.workspaceSlug)
  const { labels, isLoading } = useAllLabels(workspaceId)
  const { countsByLabelId } = useLabelTaskCounts(workspaceId)

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <div className="px-4 md:px-8 pt-8 pb-4 flex items-center gap-2 phone:pt-2">
        <PhoneMenuButton />
        <Tag className="size-5 text-muted-foreground" />
        <h1 className="text-2xl font-semibold">Tags</h1>
      </div>
      {!isLoading && labels.length === 0 ? (
        <TaskEmptyState
          title="No tags yet"
          description="Add labels to tasks to see them here."
        />
      ) : (
        <ul className="px-4 md:px-8 pb-8 overflow-y-auto">
          {labels.map((label) => {
            const count = countsByLabelId.get(label.id) ?? 0
            return (
              <li key={label.id}>
                <Link
                  to="/$workspaceSlug/tags/$tagId"
                  params={{ workspaceSlug, tagId: label.id }}
                  className="flex items-center gap-3 py-2 px-2 rounded hover:bg-muted/50"
                >
                  <span
                    aria-hidden
                    className="size-2.5 shrink-0 rounded-full"
                    style={{ backgroundColor: label.color }}
                  />
                  <span className="flex-1 truncate text-sm">{label.name}</span>
                  <Badge variant="secondary">{count}</Badge>
                </Link>
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}

export default TagListPage
